/// <amd-module name="Artifacts/Package/services/BuildDataService" />
import {
  getOrganizationAsync,
  isCurrentCollection,
} from "Artifacts/Root/Helpers/OrganizationHelper";
import { Build } from "Build/Client/Contracts/Build";
import { IBuildRestClient } from "Build/Client/RestClient/Build";
import { IVssService, Services, VssService } from "VSS/Platform/Context";

export interface IFeedBuildDataService extends IVssService {
  getBuildAsync(collectionId: string, projectId: string, buildId: number): Promise<Build>;
}

class BuildDataService extends VssService implements IFeedBuildDataService {
  public async getBuildAsync(
    collectionId: string,
    projectId: string,
    buildId: number,
  ): Promise<Build> {
    return this.getBuildRestClientAsync(collectionId).then((client: IBuildRestClient) => {
      return client.getBuild(projectId, buildId);
    });
  }

  private async getBuildRestClientAsync(collectionId: string): Promise<IBuildRestClient> {
    if (isCurrentCollection(this.pageContext, collectionId)) {
      return this.pageContext.getRestClient<IBuildRestClient>("IBuildRestClient");
    }

    const org = await getOrganizationAsync(this.pageContext, collectionId);
    if (org == null) {
      throw { message: "Organization " + collectionId + "not found.", status: 404 };
    }

    return this.pageContext.getRestClient<IBuildRestClient>("IBuildRestClient", {
      rootPath: org.url,
    });
  }
}

Services.add("IFeedBuildDataService", { serviceFactory: BuildDataService });
